import moment from "moment";
import { DateFormats } from "../../../core/common/Constants";
import { ICaseLawDocument } from "../../model/CaseLawDocument";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import { IOrganisation } from "../../../organisations/model/Organisation";

export interface TCaseLawDocumentPresentationModel extends ICaseLawDocument {
  organisationName: string;
  caseLawDocumentType: IDocumentType;
  formattedDate: string;
  summaryTranslation: string;
}

const CaseLawDocumentPresentationModel = (
  data: ICaseLawDocument,
  caseLawDocumentType?: IDocumentType,
  organisation?: IOrganisation,
  summaryTranslation?: string
) => {
  const handler: ProxyHandler<ICaseLawDocument> = {
    get: function (target, prop, receiver) {
      const startMoment = target.caseLawDocDate
        ? moment(target.caseLawDocDate)
        : null;
      switch (prop) {
        case "organisationName":
          return organisation?.name;
        case "caseLawDocumentType":
          return caseLawDocumentType;
        case "formattedDate":
          return startMoment?.format(DateFormats.DATE) || "";
        case "summaryTranslation":
          return summaryTranslation;
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "organisationName":
        case "caseLawDocumentType":
        case "formattedDate":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<ICaseLawDocument, TCaseLawDocumentPresentationModel>(
    data,
    handler
  );
};

export default CaseLawDocumentPresentationModel;
